<template>
  <div>
    <v-dialog v-model="dialog"
      @keydown.esc="close"
      :content-class="`${dialog_class}`"
      scrollable
      persistent>
      <v-card>
        <v-card-title class="documentDialog_title primary" dark>
          <v-layout row wrap >
          <v-flex xs11>
            <p>Edit content</p>
          </v-flex>
          <v-flex xs1 style="text-align: right;">
            <v-btn dark icon
            @click.native="close()" >
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <ckeditor :editor="editor" v-model="entity_rich_text" :config="editorConfig" ></ckeditor>
                <br />
                <v-textarea
                  color="orange orange-darken-4"
                  outline
                  :counter="1000"
                  v-model="editedEntity.comment"
                  label="Source of knowledge"
                  required />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <ApolloMutation
            :mutation="require('@/graphql/Wiki/CreateWikiChangeRequest.gql')"
            :variables="dialog && {
              WikiChangeRequestInput: {
                target_type: 'wiki_entity',
                target_id: this.editedEntity.entity_id,
                comment: this.editedEntity.comment || '',
                request_type: 'update',
                ChangeRequestFields: [{
                  target_field: 'entity_rich_text',
                  new_value_text: this.entity_rich_text
                }]
              }
            } || {}"
            @done="close()"
            @error="addError($event.message)"
          >
            <template slot-scope="{ mutate, loading }">
              <v-btn flat @click="close">Cancel</v-btn>
              <v-btn color="primary" @click="mutate()" :disabled="loading">Save</v-btn>
            </template>
          </ApolloMutation>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3>Content
    <v-icon style="font-size: 18px;" @click="editItem()" >edit</v-icon></h3>
    <br/>
    <span v-html="getWikiEntity.entity_rich_text"/>

  </div>

</template>

<script>

import { mapMutations, mapState } from 'vuex'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import GET_WIKI_ENTITY from '@/graphql/Wiki/GetWikiEntity.gql'
export default {
  name: 'RichTextSection',
  data () {
    return {
      getWikiEntity: {},
      entity_rich_text: '',
      dialog: false,
      editedEntity: false,
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      }
    }
  },
  computed: {
    ...mapState('wiki', ['entityId']),
    dialog_class () {
      return this.$vuetify.breakpoint.mdAndDown ? 'documentDialog wiki-edit-entity-lower-md' : 'documentDialog wiki-edit-entity'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    ...mapMutations(['addError']),
    editItem (item) {
      this.editedEntity = Object.assign({}, this.getWikiEntity)
      this.entity_rich_text = this.getWikiEntity.entity_rich_text
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedEntity = false
        this.editedIndex = -1
        this.entity_rich_text = ''
      }, 300)
    }
  },
  apollo: {
    getWikiEntity: {
      query: GET_WIKI_ENTITY,
      variables () {
        return {
          entity_id: parseInt(this.entityId)
        }
      },
      skip () {
        return this.$route.name !== 'wiki' || !this.entityId
      }
    }
  }
}
</script>
<style>
  .wiki-edit-entity {
    margin:0px;
    width:1185px;
  }
  .wiki-edit-entity-lower-md {
    margin:0px;
    width:100%!important;
  }
  .ck-editor__editable {
    min-height: 250px;
  }
</style>
